<template>
	<div class="basic_wrap">
		<div class="red_top_bg">

			<img class="header-logo" src="../../assets/images/header_logo.png" alt="">


		</div>

		<div class="content" v-show="!show_sign">

			<p>
				Party A (seal): <b>Sunoro</b>
				<br>
				Party B (seal): <input type="text" v-model="phone" placeholder=""
					style="border-bottom:1px solid black;text-indent:5px;">
				<br>
				
				<p style="height:8px;"></p>
				Representative(Signature):
				<img  src="../../assets/images/br.png" style="width:200px;height:100px;" />
				<br>
				Representative(Signature):
				<span>
					<span v-if="!resultImg" @click="showSign">__________</span>
					<img v-else :src="resultImg" style="width:200px;height:100px;" />
				</span>
				
				<br>
				Date: <span>{{ today }}</span>
			</p>
			<hr>
			<h1>Sunoro Promotion Agency Contract</h1>
			<p>
				Party B:
				Based on the principle of equality and voluntariness, Party A and Party B have reached the following
				agreement in accordance with relevant laws regarding Party A's invitation to Party B to become the
				promotion
				agent of Sunoro, and both parties shall abide by and implement:
			</p>

			<hr>

			<h1>Article 1. The first Facebook, YouTube promotion agency work content confirmation</h1>

			<ul>
				<li>
					1. Party A is responsible for the materials and information of Sunoro wealth management products
					provided
					to Party B. Party B agrees to publish a promotional article about the above products on Facebook and
					YouTube
					every month within the validity period of the contract, which shall not be overdue.
				</li>
				<li>
					2. Through cooperation, both parties will jointly promote the development of both parties'
					performance
					and
					create good economic and social benefits.
				</li>
				<li>
					3. If there are other cooperation projects between the two parties in the later stage, the two
					parties
					will
					sign a supplementary agreement separately.
				</li>
			</ul>

			<hr>
			<h1>Article 2. Duration of cooperation</h1>
			<ul>

				1. The cooperation period between the two parties is 1 year, from July 2022 to July 2023. After the
				expiration of the validity period, if neither party raises any objection, the validity period of this
				agreement will be automatically extended for one year.
				<p>
					2. After the extension period expires, Party A may re-sign the agreement with Party B. Under the
					same
					conditions, Party A has the priority to sign the contract.
				</p>
			</ul>

			<hr>
			<h1> Article 3 Payment and settlement of image endorsement remuneration</h1>

			<p> 1. The above-mentioned Facebook and YouTube agency promotion, the monthly remuneration of each agency
				promotion is calculated as A-level team members, the above remuneration is paid monthly (one month), the
				first payment time is within 3 working days after August 1, 2022, and the later Payment is made once a
				month, and Party A shall not delay.
			</p>
			<p>
				2. In the cooperation, Party A and Party B shall perform their respective duties, and the expenses
				incurred
				for this shall be borne by themselves.
			</p>
			<hr>
			<h1> Article 4 Rights and obligations of both parties</h1>
			<p>
				1. Party A is responsible for providing information and ideas such as the planning and design of the
				"product".
			</p>
			<p>
				2. Party A shall guarantee the legality of the products provided and not infringe the legitimate rights
				and
				interests of third parties. Party A shall be solely responsible for all criminal, civil compensation and
				administrative liabilities arising from the breach of this guarantee.
			</p>
			<p>
				3. The content of Party B's commitment to promote Party A's products must be notified to Party A in
				advance.
				After obtaining the consent of Party A, it can carry out corresponding promotion activities, and Party A
				can
				supervise Party B's promotion activities.
			</p>
			<p>
				4. Party B shall ensure that the promotion under this agreement has legal rights or has obtained legal
				authorization, and does not infringe the legitimate rights and interests of any third party; in the
				promotion process, it shall strictly abide by the norms and systems in the industry. Behaviors that
				degrade
				the value, affect the corporate image and goodwill of Party A, or take other improper means to directly
				or
				indirectly bring adverse effects to Party A. Party B shall be solely responsible for all criminal, civil
				compensation and administrative liabilities arising from the breach of this guarantee.
			</p>
			<p>
				5. Party B is responsible for all activities and public relations expenses incurred during the promotion
				activities, regardless of whether the marketing activities generate income or not.
			</p>
			<p>
				6. Party B shall not sign any agreement and other legal documents in the name of Party A without
				obtaining
				the individual written authorization of Party A, otherwise all disputes and legal liabilities arising
				therefrom shall be handled and borne by Party B, and compensation shall be paid to Party B accordingly.
				all
				losses caused. Party A has the right to unilaterally terminate this agreement and reserves the right to
				pursue relevant legal responsibilities of Party B.
			</p>
			<p>
				7. Party B guarantees the legality of all promotional activities, and assumes full legal responsibility
				for
				user complaints and other disputes arising therefrom. If the promotional content involves Party A, it
				shall
				be confirmed in writing by Party A in advance.
			</p>
			<p>
				8. During the cooperation period, both parties shall not disclose the commercial secrets of the
				cooperation-related work.
			</p>

			<hr>

			<h1>Article 5 Cancellation of the contract</h1>
			<p>
				1. Both parties may terminate this contract by mutual agreement.
			</p>

			<p>
				2. If Party B violates the provisions of the contract or refuses to perform or fails to perform the
				obligations specified in the contract, so that Party A cannot realize the purpose of this contract,
				Party A
				has the right to terminate this contract.</p>
			<p>
				3. Party A fails to pay Party B the remuneration within the time specified in this contract, and
				after Party
				B's written reminder
				Party B shall have the right to terminate this contract if payment is not made within the period.
			</p>

			<hr>
			<h1>Article 6 Confidentiality clause</h1>
			<p>
				During the execution of this agreement, both parties shall abide by the following confidentiality
				clauses:
			</p>
			<p>
				1. Neither party shall disclose any content of this agreement to a third party;
			</p>
			<p>
				2. Neither party shall disclose to third parties the intellectual property rights and corresponding
				products
				involved in this agreement, including but not limited to copyright sources, program content,
				implementation
				methods, technical ideas and other information;
			</p>
			<p>
				3. If the agreement expires due to the expiration of the validity period or the agreement is invalid due
				to
				any reason, this confidentiality clause will still take effect.
			</p>
			<p>
				4. The third party does not include the service party corresponding to the cooperation project of this
				agreement, but the party that discloses the above confidential information to the third party shall make
				reasonable commercial efforts to ensure that the disclosed information receives the same confidentiality
				treatment as this agreement from the third party.
			</p>

			<hr>

			<h1>Article 7 Liability for breach of contract</h1>

			<p>


				1. Both parties should strictly implement the terms of the contract. If there is any disagreement, both
				parties should negotiate to resolve it.
			</p>
			<p>


				2. During the cooperation period of this agreement, neither party shall cancel this contract by
				single-lens
				reflex, and the breaching party shall bear the responsibility for breach of contract.
			</p>

			<p>


				3. If Party B violates the obligations determined in this contract, Party A has the right to require
				Party B
				to demand compensation from Party B according to the actual loss of Party A.
			</p>

			<p>
				4. If Party A violates the obligation to pay remuneration as determined in this contract, Party B has
				the
				right to request Party A to pay the unpaid remuneration, and has the right to claim liquidated damages
				for
				1% of the delayed payment amount.
			</p>

			<hr>
			<h1>
				Article 8 Declaration and Warranty
			</h1>
			<p>Party A and Party B hereby declare, represent and warrant to each other as follows:</p>

			<p>
				1. It is an independent legal person legally established and validly existing;
			</p>
			<p>

				2. It is qualified to engage in the cooperation under this agreement, and the cooperation complies with
				the
				provisions of its business scope;
			</p>
			<p>
				3. Its authorized representative has been fully authorized to sign this agreement on its behalf;
			</p>
			<p>
				4. It has the ability to perform its obligations under this agreement; and such performance of
				obligations
				does not violate any binding applicable laws, nor violate the legitimate rights and interests of any
				third
				party.
			</p>
			<p>
				5. Any party who violates the above statements, representations and warranties shall be deemed to have
				violated the terms of this agreement and shall be liable for breach of contract in accordance with the
				provisions of this agreement.
			</p>
			<hr>
			<h1>Article 9 Others</h1>
			<p>
				1. Any disputes arising from this agreement shall be resolved through friendly negotiation between the
				two
				parties. If the negotiation fails, either party may file a lawsuit with the court where Party A is
				located.
			</p>
			<p>
				2. For matters not covered in this agreement, both parties shall negotiate and resolve them separately,
				and
				sign a written memorandum or supplementary agreement as an effective part of this agreement.
			</p>
			<p>
				3. This agreement is made in duplicate, each party holds one copy, and it will become effective after
				the
				representatives of both parties sign or seal it.
			</p>



		</div>


		<button class="showSignBtn" @click="submit" v-show="!show_sign && !signed">Yes,I agree</button>

		<div class="HelloWorld" v-show="show_sign">
			<div style="border: 2px solid #E6E6E6 ;background-color: white">

				<vue-esign ref="esign" :width="width" :height="600" :isCrop="isCrop" :lineWidth="lineWidth"
					:lineColor="lineColor" :bgColor.sync="bgColor" />

			</div>
			<button @click="handleReset" class="reset-btn">reset</button>
			<button @click="handleGenerate" class="yes-btn">Yes</button>
			<!-- <img :src="resultImg" alt=""> -->
		</div>


		<van-dialog v-model="show" title="mobile phone verification code" @confirm="test()" show-cancel-button
			cancelButtonText="Cancle" confirmButtonText="Submit">

			<van-field v-model="code" rows="1" autosize label="verification" type="textarea"
				placeholder="Please enter verification code" />
		</van-dialog>


	</div>
</template>

<script>
import Fetch from '../../utils/fetch'
import Vue from 'vue';
import { Dialog, Field } from 'vant';
Vue.use(Dialog).use(Field);
export default {
	name: "signature",
	data() {
		return {
			lineWidth: 6,
			lineColor: 'black',
			bgColor: '',
			resultImg: '',
			isCrop: true,
			show_sign: false,
			width: 500,
			today: "--",
			phone: "+91",
			code: "",
			show: false,
			nphone: "",
			signed: false,
		};
	},
	created() {
		this.$parent.footer("signature", false);
	},
	mounted() {

		if (this.$route.query.phone) {
			this.phone = "+" + this.$route.query.phone;
			Fetch('/index/getSignature', {
				phone: this.$route.query.phone,
			}).then(r => {
				if (r.code == 1) {
					this.resultImg = "https://www.Sunoro.today/" + r.data.file_path;
					//this.resultImg = "http://www.mm.com/" + r.data.file_path;
					this.today = r.data.time;
					this.signed = true;
				}
			})
		} else {
			this.today = new Date(new Date()).toLocaleDateString();
		}

	},
	methods: {
		test() {

			if (this.code.length != 4) {
				alert("Please enter verification code");
				return false;
			}

			Fetch('/index/signature', {
				code: this.code,
				phone: this.nphone,
				img: this.resultImg
			}).then(r => {

				if (r.code == 1) {
					alert("Signed successfully!");
					this.signed = true;
					window.location.href = "https://www.Sunoro.zone/#/signature?phone="+this.nphone;
					//window.location.href = "http://localhost:8080/#/signature?phone=" + this.nphone;
				}
			})

		},
		handleReset() {

			this.$refs.esign.reset()

		},

		handleGenerate() {

			this.$refs.esign.generate().then(res => {
				this.resultImg = res

				this.show_sign = !this.show_sign;
			}).catch(err => {
				alert(err)
			})
		},
		showSign() {
			this.show_sign = true;
		},
		submit() {

			let nstr = this.phone.replace(/[^0-9]/g, '');

			this.nphone = nstr;
			if (nstr.length != 12) {
				alert("Please enter the correct phone number");
				return false;
			}

			if (!this.resultImg) {
				alert("Please complete your signature");
				return false;
			}



			Dialog.alert({
				message: "The system will send a text message to " + this.phone + ", please enter the verification code in the verification",
				confirmButtonText: window.vm.$i18n.t('utils.confirm'),
			}).then(() => {
				Fetch("/sms/sendCode", {
					mobile: this.nphone,
					type: 1
				})
					.then((res) => {

					})
				this.show = true;
			})




		}
	}
};
</script>

<style lang="less" scoped>
.reset-btn {
	position: fixed;
	left: 20%;
	bottom: 5%;
	width: 80px;
	height: 40px;
	border: 1px solid red;
	color: white;
	background: red;
	border-radius: 5px;
	//transform: translateX(-50%) rotate(90deg);

}

.yes-btn {
	position: fixed;
	right: 20%;
	bottom: 5%;
	width: 80px;
	height: 40px;
	border: 1px solid green;
	color: white;
	background: green;
	border-radius: 5px;
	//transform: translateX(-50%) rotate(90deg);

}

.big_tit {
	color: #000000;
}

.red_top_bg {
	border-bottom: 1px solid rgba(97, 92, 92, 0.2);
}

.header-logo {
	width: 50%;
	height: 90%;
	display: block;
	margin: 0 auto;
}

.content {
	width: 100%;
	padding: 15px 15px;
	line-height: 0.8rem;
	font-size: 0.35rem;
}

.showSignBtn {
	display: block;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 40px;
	background-color: #ef5555;
	font-size: 0.5rem;
	color: rgba(255, 255, 255, 0.855);
	z-index: 888;
}

.HelloWorld {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 90%;
}
</style>
